import dynamic from "next/dynamic";

const DynamicWhatsApp = dynamic((() => import("./WhatsApp").then(mod => mod.WhatsApp)) as any, {
  ssr: false
});

export { DynamicWhatsApp };
